<template>
  <div>
    <van-popup v-model="showPop" position="right" style="height: 100%; width: 80%" @click-overlay="closePopup">
      <div class="btn-wrap">
        <div class="pop-title">
          <p>搜索筛选区</p>
          <van-icon name="cross" @click="cancel"/>
        </div>
        <div class="select_list">
          <van-collapse v-model="activeNames" accordion>
            <!-- <van-collapse-item title="客户等级" name="1">
              <van-button style="margin-right:5px;margin-bottom:5px;" :color="custLevelIndex === index ? 'blue' : ''" plain hairline size="small" v-for="(item,index) in custLevelOptions" :key="item.custLevelId" @click="handleClick('custLevel',item.custLevelId,index)">{{ item.levelName }}</van-button>
            </van-collapse-item>
            <van-collapse-item title="客户来源" name="2">
              <van-button style="margin-right:5px;margin-bottom:5px;" :color="custSourceIndex === index ? 'blue' : ''" plain hairline size="small" v-for="(item,index) in custSourceOptions" :key="item.dictValue" @click="handleClick('custSource',item.dictValue,index)">{{ item.dictLabel }}</van-button>
            </van-collapse-item>
            <van-collapse-item title="客户类型" name="3">
              <van-button style="margin-right:5px;margin-bottom:5px;" :color="custTypeIndex === index ? 'blue' : ''" plain hairline size="small" v-for="(item,index) in custTypeOptions" :key="item.dictValue" @click="handleClick('custType',item.dictValue,index)">{{ item.dictLabel }}</van-button>
            </van-collapse-item> -->
          </van-collapse>
        </div>

      </div>
      <div class="input-wrap">
        <van-cell-group>
          <van-field v-model="queryParams.boName" label="商机名称" placeholder="请填写商机名称" />
          <van-field v-model="queryParams.custName" label="客户名称" placeholder="请填写客户名称" />
          <van-field readonly clickable v-model="businessTypeName" @click="showPicker2('service')" label="业务类型" placeholder="请选择业务类型" />
          <van-field readonly clickable v-model="queryParams.boSourceName" @click="showPicker('boSource')" label="商机来源" placeholder="请选择商机来源" />
          <van-field readonly clickable v-model="queryParams.boStageIdName" @click="showPicker('boStageId')" label="商机阶段" placeholder="请选择商机阶段" />
          <van-field v-model="queryParams.userName" label="跟进人" placeholder="请填写跟进人" />
        </van-cell-group>
      </div>
      <div class="footer-btn-wrap">
        <van-button size="mini" type="primary" class="resetBtn" @click="resetQuery">重置</van-button>
        <van-button size="mini" type="info" class="submitbtn" @click="submitForm">搜索</van-button>
        <van-button size="mini" type="info" class="submitbtn" @click="cancel">取消</van-button>
      </div>
    </van-popup>
    <van-popup v-model="picker.visible" position="bottom">
      <van-picker :loading="picker.loading" :title="picker.title" show-toolbar :columns="picker.columns" @confirm="pickerConfirm" @cancel="pickerCancel" />
    </van-popup>
    <van-popup v-model="tree.typeTree" position="bottom">
      <van-cascader :title="tree.title" :options="tree.treeList" @change="treeChange" :field-names="tree.fieldNames" @close="tree.typeTree = false" @finish="onFinishTree" />
    </van-popup>
  </div>
</template>
<script>
// import { selectAllCustLevel } from "@/api/scrm/custlevel";
import { getAllStage } from '@/api/scrm/mycust'
import { Field, Popup, Icon, Button, Cell, CellGroup, CollapseItem, Divider, Collapse, Cascader } from 'vant'
import { businessTypeList } from '@/api/admi/dept'
import { getDicts } from '@/api/system/dict/data'
export default {
  name: 'SearchPop',
  props: ['show'],
  components: {
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Divider.name]: Divider,
    vanCascader: Cascader
  },
  data() {
    return {
      activeNames: ['1'],
      showPop: false,
      picker: {
        visible: false,
        title: '',
        columns: [],
        formKey: '',
        loading: false
      },
      tree: {
        type: '',
        title: '',
        typeTree: false,
        treeList: [],
        fieldNames: {

        }
      },
      serviceTypeTreeList: [],
      businessTypeName: '',
      custLevelIndex: null,
      custSourceIndex: null,
      custTypeIndex: null,
      queryParams: {
        boSourceName: null,
        boSource: null,
        boStageIdName: null,
        boStageId: null,
        businessTypeId: null
      },
      // 客户等级
      custLevelOptions: [],
      // 客户来源字典
      custSourceOptions: this.$store.state.dictOptions.custSource || [],
      // 客户类型
      custTypeOptions: this.$store.state.dictOptions.crmCustType || [],
      options: {
        boStageIdOptions: [],
        boSourceOptions: []
      }
    }
  },
  watch: {
    show: function (newVal, oldVal) { // 不能用箭头函数
      this.showPop = newVal
    }
  },
  mounted() {
    // this.getCustLevelList()
  },
  methods: {
    handleClick(type, prop, index) {
      switch (type) {
        case 'custLevel':
          this.queryParams.custLevelId = prop
          this.custLevelIndex = index
          break
        case 'custSource':
          this.queryParams.custSource = prop
          this.custSourceIndex = index
          break
        case 'custType':
          this.queryParams.custType = prop
          this.custTypeIndex = index
          break
        default:
          console.log('handleClick', type, prop)
      }
    },
    // 获取用户等级
    // getCustLevelList() {
    //   selectAllCustLevel(null).then(response => {
    //     this.custLevelOptions = response.data;
    //   });
    // },
    resetQuery() {
      this.queryParams = {
        custLevelId: null,
        custName: null,
        custSource: null,
        custType: null,
        boName: null,
        boSourceName: null,
        boSource: null,
        boStageIdName: null,
        boStageId: null,
        businessTypeId: null
      }
      this.custLevelIndex = null
      this.custSourceIndex = null
      this.custTypeIndex = null
    },
    submitForm() {
      console.log(this.queryParams)
      this.$emit('handlequery', this.queryParams)
    },
    cancel() {
      this.showPop = false
      this.$emit('update:show', false)
    },
    closePopup() {
      this.showPop = false
      this.$emit('update:show', false)
    },
    async showPicker(type) {
      this.picker.loading = true
      this.picker.columns = []
      this.picker.formKey = type
      const optionItem = type + 'Options'
      if (this.options.boStageIdOptions.length == 0) {
        // 商机阶段
        getAllStage().then(response => {
          const stageArr = response.rows
          stageArr.map(item => {
            item.dictLabel = item.stageName + '(' + item.stageValue + '%)'
            item.dictValue = item.boStageId
          })
          this.options.boStageIdOptions = stageArr
        })
      }
      if (this.options.boSourceOptions.length == 0) {
        // 商机来源
        await getDicts('crm_bo_source').then(res => {
          this.options.boSourceOptions = res.data
        })
      }
      this.picker.columns = this.options[optionItem].map((ele) => ele.dictLabel)
      this.picker.loading = false
      this.picker.visible = true
    },
    pickerConfirm(value, key) {
      const optionItem = this.picker.formKey + 'Options'
      const name = this.picker.formKey + 'Name'
      this.queryParams[this.picker.formKey] = this.options[optionItem][key].dictValue
      this.queryParams[name] = this.options[optionItem][key].dictLabel
      this.picker.visible = false
      console.log(this.queryParams)
    },
    pickerCancel() {
      this.picker.visible = false
    },
    async showPicker2(val) {
      if (val === 'service') {
        if (this.serviceTypeTreeList.length == 0) {
        // 获取获取业务类型
          await businessTypeList({ pageNum: 1, pageSize: 500 }).then((response) => {
            if (response.code === 200) {
              this.serviceTypeTreeList = this.getData(response.rows)
            }
          })
        }
        this.tree = {
          type: val,
          title: '请选择业务类型',
          typeTree: true,
          treeList: this.serviceTypeTreeList,
          fieldNames: {
            text: 'businessTypeName',
            value: 'businessTypeId'
          }
        }
      }
    },
    // 去除树形数据的空children
    removeEmptyChildren(node) {
      node.forEach(item => {
        if ('children' in item && item.children.length === 0) {
          delete item.children
        } else if ('children' in item && item.children.length) {
          this.removeEmptyChildren(item.children)
        }
      })
      return node
    },
    /** 转换业务类型数据结构 */
    getData (arr) {
      // 利用两层filter实现
      const data = arr.filter(item => {
        item.children = arr.filter(e => {
          return item.businessTypeId === e.parentId
        })
        return !item.parentId
      })
      return this.removeEmptyChildren(data)
    },
    treeChange(obj) {

    },
    onFinishTree(obj) {
      if (this.tree.type === 'service') {
        this.queryParams.businessTypeId = obj.value
        this.businessTypeName = obj.selectedOptions.map((option) => option.businessTypeName).join('/')
      }
      this.tree.typeTree = false
    }
  }
}
</script>
<style lang="less">
.btn-wrap {
  width: 100%;
  box-sizing: border-box;
  .close-icon {
    width: 20px;
    height: 20px;
  }
  .pop-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 36px;
    font-weight: bold;
    padding: 0;
    padding: 0 30px;
  }
  .type-list {
    margin-bottom: 40px;
    .title {
      font-size: 28px;
      font-weight: bold;
    }
    .list-wrapper {
      line-height: 0.5;
    }
  }
  .input-wrap {
    margin-top: 20px;
  }
  .select_list {
    .van-button {
      margin-top: 10px !important;
      margin-bottom: 10px !important;
    }
  }
}
.footer-btn-wrap {
  position: fixed;
  bottom: 100px;
  padding: 20px;
  width: 100%;
  box-sizing: border-box;
  padding: 0 30px;

  display: flex;
  justify-content: space-around;

  .van-button {
    width: 45%;
    height: 60px;
    font-size: 30px;

    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  }
}
</style>
